import getQueryUtils, { attributeKeys } from './queryUtils';
import REQUIRED_FIELDS_PUBLIC from './REQUIRED_FIELDS_PUBLIC';
import REQUIRED_FIELDS_PAST from './REQUIRED_FIELDS_PAST';
import { useConnect } from '@lore/query-connect';
import queryString from 'query-string';
import { $aggregations_distance } from '@/utils/query-helpers';

export default function useQuery(props) {
  const {
    search = {},
    pageSize = 4,
    showPast = false,
    distance = {}
  } = props;

  const queryUtils = getQueryUtils(search, attributeKeys);

  return useConnect('project.find', {
    where: {
      // distance: _.pick(distance, ['latitude', 'longitude']),
      eager: {
        $aggregations: $aggregations_distance(distance, 'site'),
        $where: {
          $and: [
            ...queryUtils.where,
            ...(showPast ? REQUIRED_FIELDS_PAST : REQUIRED_FIELDS_PUBLIC).$and
          ]
        }
      }
    },
    pagination: {
      page: queryString.parse(location.search).page || '1',
      pageSize: pageSize,
      order: search.order || 'createdAt desc'
    }
  }, { keepPreviousData : true });
}
